export const readyMessage = () => ({
    type: "ready"
});
//# sourceMappingURL=ready.js.map